import { UserRole } from '../types/session';

const isAdmin = (userRoles?: UserRole[]): boolean => {
  if (!Array.isArray(userRoles)) return false;
  return userRoles.includes(UserRole.ADMIN) || userRoles.includes(UserRole.SUPER_ADMIN);
};

export default isAdmin;
